import { j as s } from "../../../node_modules/react/jsx-runtime.js";
import { useState as T, useRef as F, useCallback as f, useEffect as z, cloneElement as H } from "react";
import { createPortal as K } from "react-dom";
import h from "../../../node_modules/lodash/isEmpty.js";
import { clsx as L } from "../../../node_modules/clsx/dist/clsx.m.js";
import P from "../../atoms/CompactButton/CompactButton.js";
import O from "../../atoms/Button/Button.js";
import V from "../../atoms/LinkButton/LinkButton.js";
import q from "../../atoms/StepperDot/StepperDot.js";
import i from "./Modal.module.scss.js";
import { FeaturedIcon as G } from "../../atoms/FeaturedIcon/FeaturedIcon.js";
import { Typography as M } from "../../atoms/Typography/Typography.js";
import J from "../../atoms/Checkbox/Checkbox.js";
const le = (A) => {
  var C, I, N, w, S;
  const {
    open: l,
    variant: r = "info",
    size: E = "medium",
    disableCloseOut: d = !1,
    trigger: v,
    header: t,
    footer: e,
    children: g,
    fancy: j = r !== "neutral",
    testId: R,
    zIndex: B,
    onClose: m
  } = A, [o, x] = T(l), [D, b] = T(!1), u = F(null), U = F(null), W = {
    info: "primary",
    success: "primary",
    warning: "primary",
    neutral: "primary",
    danger: "danger"
  }, $ = () => {
    setTimeout(() => {
      var n;
      (n = u.current) == null || n.classList.remove("animate-fadeInUp");
    }, 250), x(!o);
  }, y = f(() => {
    var n, a;
    d && ((a = (n = u.current) == null ? void 0 : n.classList) == null || a.add("animate-shake"), setTimeout(() => {
      var c;
      (c = u.current) == null || c.classList.remove("animate-shake");
    }, 100));
  }, [d]), p = f(() => {
    b(!0), setTimeout(() => {
      b(!1), x(!1), m == null || m();
    }, 200);
  }, [m]), k = f(() => {
    d ? y() : p();
  }, [d, p, y]);
  return z(() => {
    l !== void 0 && x(l);
  }, [l]), z(() => {
    o ? document.body.classList.add("overflow-y-hidden") : document.body.classList.remove("overflow-y-hidden");
  }, [o]), /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    v && /* @__PURE__ */ s.jsx("div", { className: "w-fit", children: H(v, {
      onClick: $
    }) }),
    o && K(
      /* @__PURE__ */ s.jsxs(
        "div",
        {
          className: i.modalContainer,
          style: { zIndex: B },
          ref: U,
          "data-testid": R,
          children: [
            /* @__PURE__ */ s.jsx(
              "div",
              {
                className: i.outSideModal,
                onClick: k,
                onKeyDown: k,
                role: "button",
                tabIndex: 0
              }
            ),
            /* @__PURE__ */ s.jsxs(
              "div",
              {
                className: L(
                  i.modal,
                  i[`${E}Modal`],
                  j && i[`${r}Fancy`],
                  {
                    [i.fancy]: j,
                    "animate-fadeInUp": o,
                    "animate-fadeOutUp": D
                  }
                ),
                ref: u,
                children: [
                  ((t == null ? void 0 : t.title) || (t == null ? void 0 : t.description) || (t == null ? void 0 : t.leadingSpace) || (t == null ? void 0 : t.withClose)) && /* @__PURE__ */ s.jsxs("div", { className: i.modalHeader, children: [
                    /* @__PURE__ */ s.jsxs("div", { className: "flex gap-200", children: [
                      ((C = t.leadingSpace) == null ? void 0 : C.icon) && !((I = t.leadingSpace) != null && I.custom) && /* @__PURE__ */ s.jsx("div", { className: "rounded-[100%] shadow-ambient h-fit", children: /* @__PURE__ */ s.jsx(
                        G,
                        {
                          iconName: t.leadingSpace.icon,
                          colorType: r,
                          variant: "tinted",
                          size: t != null && t.description ? "lg" : "md",
                          rounded: !0
                        }
                      ) }),
                      ((N = t.leadingSpace) == null ? void 0 : N.custom) && /* @__PURE__ */ s.jsx(s.Fragment, { children: (w = t.leadingSpace) == null ? void 0 : w.custom }),
                      /* @__PURE__ */ s.jsxs("div", { className: "flex flex-col gap-100 justify-center pr-150", children: [
                        t.title && /* @__PURE__ */ s.jsx(
                          M,
                          {
                            text: t.title,
                            variant: "interface/strong/ml",
                            testId: t.titleTestId
                          }
                        ),
                        t.description && /* @__PURE__ */ s.jsx(
                          M,
                          {
                            text: t.description,
                            variant: "body-new/regular",
                            testId: t.descriptionTestId,
                            textColor: "color/fg/light"
                          }
                        )
                      ] })
                    ] }),
                    t.withClose && /* @__PURE__ */ s.jsx(
                      P,
                      {
                        icon: "x",
                        variant: "ghost",
                        testId: t.closeIconTestId,
                        onClick: p
                      }
                    )
                  ] }),
                  g && /* @__PURE__ */ s.jsx("div", { className: "px-300 py-075", children: g }),
                  ((e == null ? void 0 : e.submit) || (e == null ? void 0 : e.cancel) || (e == null ? void 0 : e.checkbox) || (e == null ? void 0 : e.link) || (e == null ? void 0 : e.stepper)) && /* @__PURE__ */ s.jsxs("div", { className: i.modalFooter, children: [
                    !e.fullWidth && /* @__PURE__ */ s.jsxs("div", { className: i.footer3rdActions, children: [
                      !h(e.stepper) && /* @__PURE__ */ s.jsx(
                        q,
                        {
                          active: e.stepper.active,
                          count: e.stepper.count ?? 0,
                          onChange: e.stepper.onChange,
                          size: "medium"
                        }
                      ),
                      !h(e.link) && /* @__PURE__ */ s.jsx(
                        V,
                        {
                          variant: "neutral",
                          ...e.link
                        }
                      ),
                      !h(e.checkbox) && /* @__PURE__ */ s.jsx(
                        J,
                        {
                          label: e.checkbox.label,
                          active: e.checkbox.active,
                          onChange: (n) => {
                            var a;
                            return (a = e.checkbox) == null ? void 0 : a.onChange(n.target.checked);
                          },
                          testId: (S = e.checkbox) == null ? void 0 : S.testId
                        }
                      )
                    ] }),
                    /* @__PURE__ */ s.jsxs(
                      "div",
                      {
                        className: L(
                          i.mainFooterActions,
                          e.fullWidth && i.footerFullWidth
                        ),
                        children: [
                          e.cancel && /* @__PURE__ */ s.jsx(
                            O,
                            {
                              ...e.cancel,
                              onClick: async (n) => {
                                var a, c;
                                await ((c = (a = e.cancel) == null ? void 0 : a.onClick) == null ? void 0 : c.call(a, n)), p();
                              },
                              variant: "outlined",
                              color: "neutral",
                              size: "medium"
                            }
                          ),
                          e.submit && /* @__PURE__ */ s.jsx(
                            O,
                            {
                              ...e.submit,
                              variant: "filled",
                              color: W[r],
                              size: "medium"
                            }
                          )
                        ]
                      }
                    )
                  ] })
                ]
              }
            )
          ]
        }
      ),
      document.body
    )
  ] });
};
export {
  le as default
};
//# sourceMappingURL=Modal.js.map
